








import { createComponent, computed } from "@vue/composition-api";
import { ChatMessage } from "@/types";
import { useGetters } from "@/helpers";

export default createComponent({
  props: {
    message: {
      type: Object as () => ChatMessage,
      required: true,
    },
  },
  setup(props, context) {
    const nameColour = computed(() => {
      let c: [number, number, number] | undefined = props.message.sender.colour;
      if (c) {
        return {
          color: "rgb(" + c.map(n => Math.min(255, Math.max(0, n))).join(", ") + ")",
        };
      }
      return {};
    });
    const { user } = useGetters("user");
    const sendrecieve = computed(() => {
      return user.value && user.value.id === props.message.sender.id
        ? "sent"
        : "recieved";
    });
    const time = computed(() => new Date(props.message.time).toLocaleString("en-GB"));
    return {
      nameColour,
      sendrecieve,
      time,
    };
  },
});
